<template>
  <v-card elevation="0" flat outlined tile>
    <v-card-title>
      <v-row>
        <v-col class="d-flex justify-center">Sessioni Giornaliere</v-col>
      </v-row>
    </v-card-title>
    <column-chart
      :messages="{ empty: 'Non ci sono dati' }"
      :data="data"
      :library="library"
    ></column-chart>
  </v-card>
</template>

<script>
export default {
  name: 'SessionsPerDay',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      library: {
        layout: {
          padding: {
            left: 16,
            right: 16,
            top: 0,
            bottom: 16,
          },
        },
        legend: { display: false, position: 'bottom' },
      },
    }
  },
}
</script>
